/*!
 * @websanova/vue-upload v1.8.1
 * https://websanova.com/docs/vue-upload
 * Released under the MIT License.
 */

var axios = {
  post: function (data) {
    var cancelTokenSource = this.ctx.axios.CancelToken.source();
    this.ctx.axios.post(data.url, data.body, {
      onUploadProgress: data.progress,
      cancelToken: cancelTokenSource.token
    }).then(data.success, data.error);
    return {
      abort: function () {
        cancelTokenSource.cancel();
      }
    };
  }
};

export default axios;



//////////////////
// WEBPACK FOOTER
// ./~/@websanova/vue-upload/dist/drivers/http/axios.esm.js
// module id = 253
// module chunks = 1